// src/Pages/Landing/JoyridePoriLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";

export default function JoyridePoriLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Pori"
      maakunta="Satakunta"
      nearbyAreas={[
        "Rauma",
        "Ulvila",
        "Harjavalta",
        "Kokemäki",
        "Eura",
        "Huittinen"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Porissa ja Satakunnan alueella tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Pori sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja kesäjuhliin, kun juhliin halutaan energinen livebändi."
      logisticsText="Porin keikoissa kokonaisuus sovitaan aina tapahtumapaikan, aikataulun ja keikan keston mukaan. Bilebändi Joyridellä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
    />
  );
}